// Detect a PostgREST write that RLS silently blocked.
//
// An UPDATE/DELETE the caller isn't permitted to make affects 0 rows and
// returns NO error, so code that only checks `error` reports false success — the
// row stays unchanged while the UI acts as if it saved. This was the root cause
// of several "my edit didn't save / delete didn't stick" reports (see migs
// 120/121/122 — coordinator visibility wider than write permission).
//
// Call this on the result of a write that ends in `.select(...)` so there are
// rows to count:
//
//   const blocked = writeBlocked(await supabase.from(t).update(x).eq('id', id).select('id'))
//   if (blocked) { alert('Could not save: ' + blocked); return }
//
// Returns a human-readable reason string when the write did NOT land (real error
// or 0 rows), or null when at least one row was written.
export function writeBlocked(result) {
  const { data, error } = result || {}
  if (error) return error.message
  if (!data || data.length === 0) {
    return "you don't have permission to change it — ask whoever created it, or turn on coordinator mode"
  }
  return null
}
